import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import styled, { css } from 'styled-components';
import { media } from '@deerplusofficial/pos-helper';
import { Button } from '@deerplusofficial/pos-components';

const Container = styled(Button).attrs({
  primary: true,
  icon: 'check',
})`
  ${media(
    'tablet',
    css`
      width: 250px;
      align-self: flex-end;
    `
  )};
`;

class CheckoutButton extends React.PureComponent {
  static propTypes = {
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
  };

  static defaultProps = {
    loading: false,
    disabled: false,
    onClick: _.identity,
  };

  render() {
    const { loading, disabled, onClick } = this.props;

    return (
      <Container loading={loading} disabled={disabled} onClick={onClick}>
        付款完成
      </Container>
    );
  }
}

export default CheckoutButton;



// WEBPACK FOOTER //
// ./src/components/CheckoutPanel/CheckoutButton.js